import React from 'react'
import { connect } from 'react-redux'
import axios from '~/data/http/axios'
import Alert from '~/Common-Objects/UI/Alert'
import AutoComplete from '~/Common-Objects/AutoComplete'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Column from '~/Common-Objects/Grids/Column/Column'
import Drawer from '~/Common-Objects/UI/Drawer/Drawer.jsx'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import NewUserForm from '~/Common-Objects/NewUserForm/newUserForm.jsx'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SnackBar from '~/Common-Objects/UI/Notifications/SnackBar/SnackBar'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import EmailValidator from '~/Classes/emailValidator'
import PermissionChecker from '~/Classes/permissions'
import * as siteActions from '../../../../data/actions/siteActions'
import textFunctions from '~/Classes/textFunctions'
import DBConnection from '~/Classes/siteVars'
import { textDecoration } from '~/Classes/dragAndDropDefaults'
import helpers from '~/Classes/helpers'

//CONNECT TO STORE

@connect((store) => {
    return { user: store.user, accountMaster: store.accountMaster, permissionStore: store.permission }
})
export default class EmailPreviewer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            templateId: 0,
            templateName: '',
            emailAddresses: [],
            screenSize: '100%',
            alertMessage: '',
            alertOpen: false,
            errorMessage: '',
            groupData: [],
            currentGroup: -1,
            iframeSrc: '',
            loaded: false,
            currentSubs: [],
            previewSubOffset: 0,
            campaignData: {},
            downloadingPdf: false,
            downloadingPdfTimeTaken: 0,
            after: undefined,
            previewEmail: '',
            previewId: 0,
            reset: 0,
            approveDrawer: null,
            sendingPreview: false
        }

        this.loadTemplate = this.loadTemplate.bind(this)
        this.goSendPreview = this.goSendPreview.bind(this)
        this.changeEmail = this.changeEmail.bind(this)
        this.addEmailAddress = this.addEmailAddress.bind(this)
        this.changeGroup = this.changeGroup.bind(this)
        this.closeAlert = this.closeAlert.bind(this)
        this.goValidateDomain = this.goValidateDomain.bind(this)
        this.nextSubscriber = this.nextSubscriber.bind(this)
        this.prevSubscriber = this.prevSubscriber.bind(this)
        this.genIframe = this.genIframe.bind(this)
        this.loadCampaign = this.loadCampaign.bind(this)
        this.downloadPdf = this.downloadPdf.bind(this)
        this.loadGroups = this.loadGroups.bind(this)
    }

    componentDidMount() {
        var emailAddresses = [{ emailAddress: this.props.user.userData.emailAddress, errorText: '' }]
        this.setState({ templateId: this.props.templateId, emailAddresses: emailAddresses }, () => {
            if (this.props.fromCampaignId) {
                this.loadCampaign()
            } else {
                this.loadTemplate()
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.templateId !== prevProps.templateId) {
            var emailAddresses = [{ emailAddress: this.props.user.userData.emailAddress, errorText: '' }]
            this.setState({ templateId: this.props.templateId, emailAddresses: emailAddresses, loaded: false }, () => {
                if (this.props.fromCampaignId) {
                    this.loadCampaign()
                } else {
                    this.loadTemplate()
                }
            })
        }
    }

    loadCampaign() {
        axios.get(`/campaign/${this.props.fromCampaignId}`).then((_campaignData) => {
            this.setState({ campaignData: _campaignData.data.Campaign }, this.loadTemplate)
        })
    }

    async loadGroups() {
        const arr = []
        try {
            let offset = 0
            while (true) {
                const res = await axios.get('/group?recordLimit=200&startRecord=' + offset)
                if (res.data.Groups?.length) {
                    arr.push(...res.data.Groups)
                    if (res.data.Groups.length < 200) break
                    offset += res.data.Groups.length
                } else {
                    break
                }
            }
        } catch (e) {}
        return arr
    }

    async loadTemplate() {
        var thisTemplateData
        let groupData
        const res = await axios.get(`/template/${this.state.templateId}`)
        thisTemplateData = res.data
        if (PermissionChecker('subscribers', this.props.permissionStore.permissions, 'read')) {
            groupData = await this.loadGroups()
        }
        var templateName = thisTemplateData.template.templateName
        var theIframeSrc = await this.genIframe(0)
        this.setState({
            iframeSrc: theIframeSrc,
            CampaignId: thisTemplateData.template.CampaignId,
            templateName: templateName,
            groupData: groupData || [],
            loaded: true
        })
    }

    changeEmail(event, index) {
        var theEmails = this.state.emailAddresses
        theEmails[index].emailAddress = event.target.value
        this.setState({ emailAddresses: theEmails })
    }

    addEmailAddress(e) {
        e.preventDefault()
        var theEmails = this.state.emailAddresses
        if (theEmails.length < 5) {
            theEmails.push([{ emailAddress: '', errorText: '' }])
        }
        this.setState({ emailAddresses: theEmails })
    }

    goValidateDomain() {
        this.props.history.push('/cp/company/domains')
    }

    goSendPreview() {
        var self = this

        this.setState({ sendingPreview: true })
        var emailsToSend = []
        var failed = false
        var origEmails = this.state.emailAddresses
        for (var email in origEmails) {
            var thisEmail = origEmails[email].emailAddress
            var okToGo = false
            if (EmailValidator.validateEmail(thisEmail) === true) {
                emailsToSend.push(thisEmail)
                origEmails[email].errorText = ''
                okToGo = true
            }
            if (!thisEmail) {
                okToGo = true
                origEmails[email].errorText = ''
            }
            if (okToGo == false) {
                failed = true
                origEmails[email].errorText = i18n.t('templates:preview.invalid')
            }
        }

        if (failed === false) {
            var previewData = {
                emailAddress: emailsToSend,
                subject: this.props.subject
            }
            if (this.state.currentGroup && this.state.currentGroup >= 0) {
                if (
                    this.state.currentSubs &&
                    this.state.currentSubs.length &&
                    this.state.currentSubs[this.state.previewSubOffset]
                ) {
                    var ourSubId = this.state.currentSubs[this.state.previewSubOffset].subscriberId
                    previewData.previewAsSubscriberId = ourSubId
                }
            } else if (this.state.previewEmail && this.state.previewId) {
                previewData.previewAsSubscriberId = parseInt(this.state.previewId)
            }

            if (this.props.turnOffTracking && this.props.turnOffTracking == true) {
                previewData.trackLinks = false
                previewData.trackOpens = false
            }

            previewData.fromAddress = this.props.fromAddress
            previewData.fromName = this.props.fromName
            previewData.CdnDomainId = this.props.CdnDomainId
            previewData.TrackingDomainId = this.props.TrackingDomainId

            axios
                .post('/template/preview/' + this.state.templateId, previewData)
                .then((res) => {
                    this.props.dispatch(siteActions.alterSnackbar(true, i18n.t('templates:preview.sent')))
                    self.setState({ emailAddresses: origEmails, sendingPreview: false })
                })
                .catch(function (error) {
                    var alertMessage = i18n.t('templates:preview.error')
                    var errorMessage = ''
                    if (error.data.error.replyAddress) {
                        errorMessage = (
                            <Column xs={12} sm={12} md={12} margin={0}>
                                <div className='text-red mar-b15'>
                                    You must verify your account email address{' '}
                                    <strong>{self.props.user.userData.emailAddress}</strong> before you can send preview
                                    emails
                                </div>

                                <Button
                                    className='button-sml min-shadow outline red'
                                    text='Verify your Email Address'
                                    onClick={self.goValidateDomain}
                                />
                            </Column>
                        )
                    }

                    this.props.dispatch(siteActions.alterSnackbar(true, error.data.error || alertMessage))
                    self.setState({ emailAddresses: origEmails, errorMessage: errorMessage, sendingPreview: false })
                })
        } else {
            self.setState({ emailAddresses: origEmails, sendingPreview: false })
        }
    }
    changeScreenSize(type) {
        var screenSize = '100%'
        if (type === 1) {
            screenSize = '768px'
        }
        if (type === 2) {
            screenSize = '480px'
        }
        this.setState({ screenSize: screenSize })
    }
    async changeGroup(event) {
        var newGroupId = event.currentTarget.value
        if (isNaN(newGroupId)) {
            return
        }

        this.setState({ currentGroup: newGroupId, reloading: true })

        if (newGroupId == 0) {
            var queryStr = '?ignoreLog=1&limit=50offset=0'
            if (this.state.campaignData.options && this.state.campaignData.options.filterSegments) {
                queryStr += '&filterSegments=true'
            }

            const response = await axios.post('/campaign/countresults' + queryStr, {
                Segments: this.state.campaignData.Segments,
                Groups: this.state.campaignData.Groups
            })
            if (response.data && response.data.rows && response.data.rows.length) {
                var ourSubs = response.data.rows
                var ourSubId = 0
                if (ourSubs && ourSubs.length > 0) {
                    ourSubId = ourSubs[0].id
                }
                var theIframeSrc = await this.genIframe(ourSubId)
                var currentSubs = response.data.rows.map((sub) => {
                    return { subscriberId: sub.id, emailAddress: sub.emailAddress }
                })
                this.setState({
                    iframeSrc: theIframeSrc,
                    reloading: false,
                    previewSubOffset: 0,
                    currentSubs: currentSubs
                })
            } else {
                this.setState({ reloading: false, previewSubOffset: 0 })
            }
        } else {
            const response = await axios.get('/group/' + newGroupId + '/subscriber?recordLimit=50&active=true')
            if (response.data && response.data.Subscribers && response.data.Subscribers.length) {
                var ourSubs = response.data.Subscribers
                var ourSubId = 0
                if (ourSubs && ourSubs.length > 0) {
                    ourSubId = ourSubs[0].subscriberId
                }
                var theIframeSrc = await this.genIframe(ourSubId)
                this.setState({
                    iframeSrc: theIframeSrc,
                    reloading: false,
                    previewSubOffset: 0,
                    currentSubs: response.data.Subscribers
                })
            } else {
                this.setState({ reloading: false, previewSubOffset: 0 })
            }
        }
    }

    async nextSubscriber() {
        var subId = this.state.previewSubOffset + 1
        if (subId > 50) subId = 0
        var ourSubId = 0
        var ourSubs = this.state.currentSubs

        if (!ourSubs[subId]) {
            subId = 0
            ourSubId = ourSubs[0].subscriberId
        } else {
            ourSubId = ourSubs[subId].subscriberId
        }

        var iframeSrc = await this.genIframe(ourSubId)
        this.setState({ iframeSrc: iframeSrc, previewSubOffset: subId })
    }
    async prevSubscriber() {
        var subId = this.state.previewSubOffset - 1
        var ourSubs = this.state.currentSubs
        if (subId < 0) subId = ourSubs.length - 1

        var ourSubId = 0
        if (!ourSubs[subId]) {
            subId = 0
            ourSubId = ourSubs[0].subscriberId
        } else {
            ourSubId = ourSubs[subId].subscriberId
        }
        var iframeSrc = await this.genIframe(ourSubId)
        this.setState({ iframeSrc: iframeSrc, previewSubOffset: subId })
    }

    async genIframe(ourSubId) {
        var key = await helpers.createKey(ourSubId, 0, 0, this.props.CampaignId || 0)
        var baseUrl = DBConnection.getConnString()
        let theIframeSrc =
            baseUrl +
            `/templatePreview?key=${key}&templateId=${this.state.templateId}&showClicks=false&type=&bots=&html=true&_=${Date.now()}`
        //var theIframeSrc = "/preview?key=" + key + "&tid=" + this.state.templateId;
        return theIframeSrc
    }
    closeAlert() {
        this.setState({ alertOpen: false, alertMessage: '' })
    }
    downloadPdf() {
        this.setState({ downloadingPdf: true, downloadingPdfTimeTaken: 0 })
        let downloadStartTime = Date.now()
        let monitoringThread = setInterval(() => {
            this.setState({ downloadingPdfTimeTaken: Date.now() - downloadStartTime })
        }, 500)
        axios
            .get('/template/' + this.state.templateId + '/exportpdf', {
                responseType: 'blob'
            })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'template_' + this.state.templateId + '.pdf')
                document.body.appendChild(link)
                link.click()
                monitoringThread = clearTimeout(monitoringThread)
                this.setState({ downloadingPdf: false })
            })
    }

    activate() {
        var theDrawer = (
            <NewUserForm
                from='email'
                finish={() => {
                    this.setState({ approveDrawer: null })
                }}
            />
        )
        this.setState({ approveDrawer: theDrawer })
    }

    async previewRandom() {
        this.setState({ searching: true, reset: Date.now() })
        const beta = Boolean(this.props.accountMaster.accountMaster.beta?.QueryBuilder)
        let q = '?limit=1&orderBy=-1&orderDir=asc'
        if (this.state.after) {
            if (beta) {
                q += '&offset=' + this.state.after
            } else {
                this.state.after.forEach((a) => (q += '&after=' + a))
            }
        }
        const res = await axios.get('/campaign/' + this.state.CampaignId + '/contacts' + q)
        this.setState({ searching: false })
        let subId, emailAddress
        if (beta) {
            if (res.data.rows?.length) {
                subId = res.data.rows[0].id
                emailAddress = res.data.rows[0].emailAddress
                this.setState({ after: (this.state.after || 0) + 1 })
            } else {
                return this.setState({ after: (this.state.after || 0) + 1 }, this.previewRandom)
            }
        } else {
            if (!res.data.hits.hits || !res.data.hits.hits.length) {
                if (this.state.after) {
                    return this.setState({ after: null }, this.previewRandom)
                } else {
                    return this.props.dispatch(siteActions.alterSnackbar(true, 'No Contacts Found'))
                }
            }
            this.setState({
                after: res.data.hits.hits[0].sort
            })
            subId = res.data.hits.hits[0]._id.split('_')[1]
            emailAddress = res.data.hits.hits[0]._source.emailAddress
        }
        const iframeSrc = await this.genIframe(subId)
        this.setState({ iframeSrc, previewEmail: emailAddress, previewId: subId })
    }

    async updateEmailSearch(ev) {
        const iframeSrc = await this.genIframe(ev.value)
        this.setState({ previewEmail: ev.label, iframeSrc, previewId: ev.value })
    }

    render() {
        if (this.state.loaded) {
            var groupData = JSON.parse(JSON.stringify(this.state.groupData))
            if (!groupData) groupData = []
            if (this.props.fromCampaignId) {
                groupData.unshift({ id: 0, groupName: 'Campaign Recipients' })
            }

            const approved = this.props.accountMaster.accountMaster.approved

            return (
                <div className='emailPreviewHolder'>
                    <Row>
                        <Column xs={12} className='mar-b10' hide={['xs']}>
                            <div className='emailPreviewHolder-devices'>
                                <div className='emailPreviewHolder-devices-toggle'>
                            <ButtonSimple
                                toolTipFor='desktop'
                                className='button-simple-fullsize mar-r5'
                                selected={this.state.screenSize === '100%' && 'selected'}
                                onClick={() => {
                                    this.changeScreenSize(0)
                                }}
                                data-ph='dragdrop-preview-desktop'
                                tooltip='Desktop'
                            >
                                <Icons icon='monitor' color='#525150' />
                            </ButtonSimple>

                            <ButtonSimple
                                toolTipFor='tablet'
                                className='button-simple-fullsize mar-r5'
                                selected={this.state.screenSize === '768px' && 'selected'}
                                onClick={() => {
                                    this.changeScreenSize(1)
                                }}
                                data-ph='dragdrop-preview-tablet'
                                tooltip='Tablet'
                            >
                                <Icons icon='tabletOutline' color='#525150' />
                            </ButtonSimple>

                            <ButtonSimple
                                toolTipFor='mobile'
                                className='button-simple-fullsize '
                                selected={this.state.screenSize === '480px' && 'selected'}
                                onClick={() => {
                                    this.changeScreenSize(2)
                                }}
                                data-ph='dragdrop-preview-mobile'
                                tooltip='Mobile'
                            >
                                <Icons icon='mobileOutline' color='#525150' />
                            </ButtonSimple>
                                </div>
                            </div>
                        </Column>
                    </Row>

                    <Row>
                        <Column xs={12} sm={8} className='mar-b25'>
                            <div className='innerPreviewHolder' style={{ maxWidth: this.state.screenSize }}>
                                {!this.state.reloading && (
                                    <iframe
                                        width='100%'
                                        height='100%'
                                        style={{ border: '0' }}
                                        src={this.state.iframeSrc}
                                    ></iframe>
                                )}
                                {this.state.reloading && <LoadingIcons iconType='2' />}
                            </div>
                        </Column>
                        <Column xs={12} sm={4}>
                            <div className='emailPreviewOptions'>
                                <h4 className='mar-b25'>{i18n.t('templates:preview.header')}</h4>

                                <Paper>
                                    <div className='txtInput_label'>{i18n.t('templates:preview.sendTestTo')}</div>
                                    {this.state.emailAddresses.map((theEmail, index) => {
                                        return (
                                            <div style={{ marginBottom: '15px' }} key={'emailT' + index}>
                                                <TextInput
                                                    placeholder='Enter email address'
                                                    value={theEmail.emailAddress}
                                                    name='groupName'
                                                    readOnly={!approved}
                                                    focus={true}
                                                    onChange={(event) => {
                                                        this.changeEmail(event, index)
                                                    }}
                                                    error={theEmail.errorText}
                                                />
                                            </div>
                                        )
                                    })}

                                    {this.state.emailAddresses.length < 5 && approved && (
                                        <a
                                            href=''
                                            onClick={this.addEmailAddress}
                                            className='quickFlex'
                                            style={{ alignItems: 'center', gap: '2px', textDecoration: 'none' }}
                                            data-ph='dragdrop-preview-add-another-email'
                                        >
                                            <Icons icon='plus' style={{ width: '20px', height: '20px' }} />
                                            {i18n.t('templates:preview.add')}
                                        </a>
                                    )}

                                    {!approved && this.props.user.userData.registered && (
                                        <span>To send previews to others, your account needs to be approved.</span>
                                    )}

                                    <div className='quickFlex mar-t16'>
                                        <Button
                                            iconLeft={<Icons icon='envelope' />}
                                            className='button-primary'
                                            text={i18n.t('templates:preview.send')}
                                            disabled={
                                                !this.state.emailAddresses.length ||
                                                !this.state.emailAddresses[0].emailAddress ||
                                                !this.props.user.userData.registered ||
                                                this.state.sendingPreview
                                            }
                                            onClick={this.goSendPreview}
                                            postHogTag='dragdrop-preview-send-test'
                                        />
                                    </div>

                                    {!approved && !this.props.user.userData.registered && (
                                        <span className='text-red mar-t16'>
                                            You must confirm your email address before you can send previews.
                                        </span>
                                    )}
                                </Paper>

                                {groupData.length > 0 && !this.state.CampaignId && (
                                    <Paper className='mar-b25'>
                                        <div>
                                            <Select
                                                filter={true}
                                                label={i18n.t('templates:preview.sub')}
                                                placeholder={i18n.t('templates:preview.selectAGroup')}
                                                data={groupData.map((theGroup, index) => {
                                                    return { value: theGroup.id, label: theGroup.groupName }
                                                })}
                                                onChange={this.changeGroup}
                                                value={this.state.currentGroup}
                                            />
                                        </div>
                                        {groupData.length > 0 && this.state.currentGroup >= 0 && (
                                            <div
                                                className='quickFlex mar-t15'
                                                style={{ justifyContent: 'space-between', alignItems: 'center' }}
                                            >
                                                <Button
                                                    iconLeft={<Icons icon='arrowLeft' />}
                                                    text={i18n.t('templates:preview.prev')}
                                                    onClick={this.prevSubscriber}
                                                />
                                                <Button
                                                    iconRight={<Icons icon='arrowRight' />}
                                                    text={i18n.t('templates:preview.next')}
                                                    onClick={this.nextSubscriber}
                                                />
                                            </div>
                                        )}
                                        {this.state.currentSubs &&
                                            this.state.currentSubs[this.state.previewSubOffset] && (
                                                <Paper
                                                    className='center-xs mar-t10 mar-b0'
                                                    style={{ padding: '10px' }}
                                                >
                                                    <div>Viewing as: </div>
                                                    {this.state.currentSubs[this.state.previewSubOffset].emailAddress}
                                                </Paper>
                                            )}
                                    </Paper>
                                )}

                                {!!this.state.CampaignId && (
                                    <Paper>
                                        <div className='mar-b10 text-heavy'>
                                            See how the content will look for a contact in this campaign
                                        </div>
                                        <div className='quickFlex' style={{ alignItems: 'center' }}>
                                            <Button
                                                disabled={this.state.searching}
                                                text='Random Contact'
                                                className='mar-r10'
                                                onClick={this.previewRandom.bind(this)}
                                                postHogTag='dragdrop-preview-random-contact'
                                            />
                                            <AutoComplete
                                                reset={this.state.reset}
                                                outerStyle={{ flexGrow: 1 }}
                                                placeholder='Or a specific email address'
                                                url='/subscriber?search={{name}}'
                                                parser={(d) =>
                                                    d.Subscribers.map((a) => ({ label: a.emailAddress, value: a.id }))
                                                }
                                                onChange={this.updateEmailSearch.bind(this)}
                                            />
                                        </div>
                                        {!!this.state.previewEmail && (
                                            <div className='mar-t20'>
                                                Previewing as: <strong>{this.state.previewEmail}</strong>
                                            </div>
                                        )}
                                    </Paper>
                                )}

                                <div className='quickFlex mar-b16'>
                                    {this.props.user.userData.registered && (
                                        <Button
                                            text={
                                                this.state.downloadingPdf
                                                    ? i18n.t('templates:preview.generatingPdf')
                                                    : i18n.t('templates:preview.downloadPdf')
                                            }
                                            onClick={this.downloadPdf}
                                            disabled={this.state.downloadingPdf}
                                            iconLeft={<Icons icon='download' />}
                                            iconRight={
                                                this.state.downloadingPdf ? (
                                                    <LoadingIcons
                                                        iconType='2'
                                                        style={{ width: 20, height: 20 }}
                                                        className='mar-l10'
                                                    />
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            postHogTag='dragdrop-preview-download-pdf'
                                        />
                                    )}
                                </div>

                                {this.state.downloadingPdf && this.state.downloadingPdfTimeTaken > 5000 && (
                                    <div className='text-red mar-b16'>
                                        <Alert
                                            type='info'
                                            content={i18n.t('templates:preview.generatingPdfSlowWarning')}
                                        />
                                    </div>
                                )}

                                {this.state.errorMessage}

                                {this.props.showSettings && (
                                    <div className='mar-t30'>
                                        {(this.state.campaignData.Groups.length > 0 ||
                                            this.state.campaignData.Segments.length > 0) && (
                                            <div className='mar-b25'>
                                                <h4 className='mar-b25'>
                                                    {i18n.t('campaigns:standard.step1.groupsAndSegments')}
                                                </h4>
                                                {this.state.campaignData.Groups.map((g) => (
                                                    <SquareChip
                                                        key={'Group_' + g.id}
                                                        tooltip={'Group'}
                                                        for={g.id}
                                                        value={g.groupName}
                                                        className='square-chip-primary'
                                                    />
                                                ))}
                                                {this.state.campaignData.Segments.map((s) => (
                                                    <SquareChip
                                                        key={'Seg_' + s.id}
                                                        tooltip={'Segment'}
                                                        for={s.id}
                                                        value={s.name}
                                                        className='square-chip-purple'
                                                    />
                                                ))}
                                            </div>
                                        )}

                                        {!!this.state.campaignData.batchSize &&
                                            !!this.state.campaignData.batchDelay &&
                                            !!this.state.campaignData.batchUnit && (
                                                <div>
                                                    <span
                                                        dangerouslySetInnerHTML={{
                                                            __html: i18n.t('campaigns:main.batchSettings', {
                                                                batchSize: textFunctions.checkForHtml(
                                                                    this.state.campaignData.batchSize
                                                                ),
                                                                batchDelay: textFunctions.checkForHtml(
                                                                    this.state.campaignData.batchDelay
                                                                ),
                                                                batchUnit: textFunctions.checkForHtml(
                                                                    this.state.campaignData.batchUnit
                                                                )
                                                            })
                                                        }}
                                                    ></span>
                                                </div>
                                            )}
                                    </div>
                                )}
                            </div>
                        </Column>
                    </Row>

                    {/* <SnackBar message={this.state.alertMessage} open={this.state.alertOpen} autoclose={true} dismiss={this.closeAlert} /> */}

                    <Drawer
                        standalone={true}
                        width='100vw'
                        isOpen={!!this.state.drawerContent}
                        showClose={true}
                        startClose={() => this.setState({ drawerContent: undefined })}
                    >
                        {this.state.drawerContent}
                    </Drawer>
                    {this.state.approveDrawer}
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
